import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import LayoutIndex from '../../pages/layout/index';
import LoginView from '../../pages/login/index';
import DisposeRoute from './disposeRoute';
import { MenuItem } from '../../pages/layout/components/sider/menuList';
import { convertBackendMenuToSiderMenu } from '@/utils/menuConverter';
import { alibabaRoutes } from './alibaba';
import { cateRoutes } from './cate';
const V404 = lazy(() => import('src/pages/404'));

// 动态生成路由
export function setRouterByMenu(menus: MenuItem[]): RouteObject[] {
  const list: RouteObject[] = [];
  menus.forEach((menu) => {
    if (menu.items && menu.items.length !== 0) {
      list.push(...setRouterByMenu(menu.items));
    } else {
      const Component = lazy(() =>
        import(`src/views${menu.path}`).catch(() => {
          console.warn(`Failed to load component for path: ${menu.path}`);
          return { default: () => <V404 /> };
        })
      );
      list.push({
        path: menu.path,
        element: (
          <DisposeRoute
            element={<Component />}
            titleId={
              menu.textId || (typeof menu.text === 'string' ? menu.text : '')
            }
            auth
          />
        ),
        children: menu.items?.length ? setRouterByMenu(menu.items) : [],
      });
    }
  });
  return list;
}

// 动态生成路由列表的函数
export function generateRouteList(): RouteObject[] {
  // 在函数调用时获取最新的菜单数据
  const currentMenus = convertBackendMenuToSiderMenu();

  return [
    {
      path: '/login',
      element: <DisposeRoute element={<LoginView />} titleId={'Login'} />,
    },
    {
      path: '/',
      element: <DisposeRoute element={<LayoutIndex />} titleId='home' auth />,
      children: [
        {
          index: true, // 默认子路由
          element: <Navigate to='/dashboard' replace />,
        },
        ...cateRoutes,
        ...alibabaRoutes,
        ...setRouterByMenu(currentMenus),
        {
          path: '*',
          element: <DisposeRoute element={<V404 />} titleId='404' />,
        },
      ],
    },
  ];
}

// 保持向后兼容的静态路由列表（作为备用）
export const routeList: RouteObject[] = generateRouteList();
